/**
 * MarkdownRenderer - Renders markdown with @mention and #hashtag highlighting.
 */

import React from 'react';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  // Process content: highlight @mentions and #hashtags, render basic markdown
  const parts = content.split(/(@\w+|#\w+|\*\*[^*]+\*\*|`[^`]+`)/g);

  return (
    <span>
      {parts.map((part, i) => {
        if (part.startsWith('@')) {
          return (
            <span key={i} className="text-blue-600 font-medium bg-blue-50 rounded px-0.5 cursor-pointer hover:underline">
              {part}
            </span>
          );
        }
        if (part.startsWith('#') && part.length > 1) {
          return (
            <span key={i} className="text-purple-600 font-medium bg-purple-50 rounded px-0.5 cursor-pointer hover:underline">
              {part}
            </span>
          );
        }
        if (part.startsWith('**') && part.endsWith('**')) {
          return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        if (part.startsWith('`') && part.endsWith('`')) {
          return (
            <code key={i} className="bg-gray-100 text-red-600 px-1 py-0.5 rounded text-xs font-mono">
              {part.slice(1, -1)}
            </code>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </span>
  );
};

export default MarkdownRenderer;
